import EmberObject from '@ember/object';
import Evented from '@ember/object/evented';

/**
 * This module exists to act as a 'shim' between Native EventTarget API, which unfortunately can't be used due to Fastboot's node environment not providing it.
 *
 * It more-or-less implements the same API as an EventTarget would have but on top of Evented mixin instead.
 */
class EsaEventTarget extends EmberObject.extend(Evented) {
  addEventListener(event, cb) {
    this.on(event, cb);
  }
  removeEventListener(event, cb) {
    this.off(event, cb);
  }
  dispatchEvent(event, value) {
    // let customEvent: CustomEvent;
    // if (value) {
    //   customEvent = new CustomEvent(event, { detail: value });
    // } else {
    //   customEvent = new CustomEvent(event);
    // }

    this.trigger(event, {
      detail: value
    });
  }
}

export { EsaEventTarget as E };
//# sourceMappingURL=event-target-DNXGVM9Z.js.map
